export enum SubscriptionStatus {
  CANCELLED,
  ACTIVE,
  PAUSED,
}

export enum SubscriptionCancellationReason {
  ACCEPTANCY = 'acceptancy',
  ADJUST = 'adjust',
  AGING = 'aging',
  BY_MISTAKE = 'by_mistake',
  DELIVERY = 'delivery',
  EXPENSIVE = 'expensive',
  FOOD_TYPE = 'food_type',
  HEALTH = 'health',
  OOS = 'OOS',
  OTHER = 'other',
  OTHER_SUPPLIER = 'other_supplier',
  TOO_MUCH = 'too_much',
  UNHAPPY_CUHA = 'unhappy_CuHa',
  UNHAPPY_WEB = 'unhappy_web',
}
